import axios from 'axios';
import { UPDATE_JOB } from '../../../constants';

export const updateJob = (jId, data, onDialogClose, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadUpdateJob());
  axios
    .put(`jobs/updateJob?jobId=${jId}`, data, config)
    .then((res) => {
      dispatch(setUpdateJob(res));
      onDialogClose();
    })
    .catch((err) => {
      dispatch(errorUpdateJob(err.response));
      onError(err.response);
    });
};

export const loadUpdateJob = () => ({
  type: UPDATE_JOB.LOAD,
});

export const setUpdateJob = (data) => ({
  type: UPDATE_JOB.SUCCESS,
  payload: data.data,
});

export const errorUpdateJob = (error) => ({
  type: UPDATE_JOB.FAIL,
  payload: error,
});
